import * as React from 'react';
import en from './en';
import ru from './ru';
import { ru as ruDFNSLocale, enUS as enDFNSLocale } from 'date-fns/locale';
import { i18nKeys } from './i18nkeys';
import { ReactNode } from 'react';

let dictionary = en;
let locale = enDFNSLocale;
let userLangDefined = false;

export function setLang(lang: string) {
  if (lang === 'ru') {
    dictionary = ru;
    locale = ruDFNSLocale;
  } else {
    locale = enDFNSLocale;
    dictionary = en;
  }

  userLangDefined = true;
}

export function isUserLangDefined() {
  return userLangDefined;
}

export function getDFNSLocale() {
  return locale;
}

export function t7e(key: i18nKeys, ...args: Array<string | number>): string {
  const v = dictionary[key];

  if (typeof v === 'function') {
    return v(args);
  }

  return v;
}

// to handle &nbsp; and so on
export function html(str: string): ReactNode {
  return React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: str,
    },
  });
}
